import { Edit3 } from 'lucide-react';
import { Skp } from '../../model/Absensi';

export let absens : Skp[] = [
]

const updateSkpsData = (updatedData = []) => {
  absens.length = 0; // Clear the existing array
  updatedData.forEach((item: any) => {
    absens.push({
      id                    : item.id || 'undefined',
      karyawan              : item.karyawan || item.id_karyawan || '',
      nilai_skp             : item.nilai_skp || '-',
      bulan_tahun           : item.bulan_tahun || '-'
    });
  });
}  

const getKaryawanName = (karyawan: any) => {
  if (!karyawan) return '-';
  if (typeof karyawan === 'string') return karyawan;
  return karyawan.nama || karyawan.username || karyawan.id || JSON.stringify(karyawan);
};

const getNilaiSkpLabel = (nilai: number | null) => {
  switch (nilai) {
    case 4: return 'Baik';
    case 3: return 'Butuh Perbaikan';
    case 2: return 'Kurang';
    case 1: return 'Sangat Kurang';
    default: return 'Baik';
  }
}

export const fetchGetSkpsAll = async () => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", key);

  const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/bawaslu_phwt/skp/all")
  const result = await fetch(apiUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => { updateSkpsData(result.data ?? []); return { "status" : result.status, "message" : result.message, data: absens }; })
      .catch((error : any) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message , data: []} });
    return result;
 }

export const fetchPatchSkp = async ({ id , skp } : { id : string; skp : number}) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions = {
    method: "put",
    headers: myHeaders,
    body: JSON.stringify({ nilai_skp: skp }),
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/bawaslu_phwt/skp/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const fetchDeleteSkp = async (id : string) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions: RequestInit = {
    method: "DELETE",
    headers: myHeaders,
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/bawaslu_phwt/skp/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

const getHariFromTanggal = (tanggal: string) => {
  const date = new Date(tanggal);
  if (isNaN(date.getTime())) return tanggal;
  return date.toLocaleDateString('id-ID', { weekday: 'long' });
};

const getWaktuFromTanggal = (tanggal?: string | null) => {
  if (!tanggal) return '-';
  try { return new Date(tanggal).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' }) }
  catch (e) { console.error(e); return tanggal }
}

// ==== Badge helpers ====
// Warna badge dikelompokkan berdasarkan makna status, bukan berdasarkan urutan tampil.
const badgeColorMap: { [key: string]: string } = {
  // status kehadiran
  hadir       : 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
  terlambat   : 'bg-amber-50 text-amber-700 ring-amber-600/20',
  alpa        : 'bg-rose-50 text-rose-700 ring-rose-600/20',
  izin        : 'bg-sky-50 text-sky-700 ring-sky-600/20',
  sakit       : 'bg-violet-50 text-violet-700 ring-violet-600/20',
  cuti        : 'bg-indigo-50 text-indigo-700 ring-indigo-600/20',
  // penyetujuan aktivitas
  approved    : 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
  disetujui   : 'bg-emerald-50 text-emerald-700 ring-emerald-600/20',
  rejected    : 'bg-rose-50 text-rose-700 ring-rose-600/20',
  ditolak     : 'bg-rose-50 text-rose-700 ring-rose-600/20',
  pending     : 'bg-amber-50 text-amber-700 ring-amber-600/20',
  none        : 'bg-gray-100 text-gray-500 ring-gray-400/20',
  // fallback
  default     : 'bg-gray-100 text-gray-600 ring-gray-500/20',
};

export const RenderTableSkp = ({ data, onOpenEdit }: { 
    data: Skp[] | null; 
    onOpenEdit : (absen: Skp) => void;
  }) => {
    const rows: any[] = [];
    let lastGroup = '';

    if (data && data.length > 0) {
      for (const skp of data) {
        const tanggalOnly = skp.bulan_tahun ? skp.bulan_tahun.split(' ')[0] : '';
        const [y = '', m = ''] = tanggalOnly.split('-');
        const groupKey = `${y}-${m}`;
        if (groupKey !== lastGroup) {
          const groupLabel = y && m ? new Date(`${y}-${m}`).toLocaleString('id-ID', {month: 'long', year: 'numeric' }) : tanggalOnly;
          rows.push(
            <tr key={`group-${groupKey}`} className="bg-gray-50">
              <td colSpan={4} className="px-6 py-2 text-sm font-semibold text-gray-700">{groupLabel}</td>
            </tr>
          );
          lastGroup = groupKey;
        }

        rows.push(
          <tr key={skp.id} className="hover:bg-gray-50 transition-colors">
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
              {getKaryawanName(skp.karyawan)}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
              {getNilaiSkpLabel(Number(skp.nilai_skp))}
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
              <button onClick={() => { onOpenEdit(skp) }} className="text-green-600 hover:text-green-900 hover:bg-green-50 p-1.5 rounded-md transition-colors" title="Edit">
                <Edit3 className="w-4 h-4" />
              </button>
            </td>
          </tr>
        );
      }
    }

    if (rows.length === 0) {
      return (
        <>
          <tr>
            <td colSpan={4} className="text-center py-4 text-gray-500">
              Tidak ada data
            </td>
          </tr>
        </>
      );
    }

    return <>{rows}</>;
}

export const fetchPutAbsensiRecord = async ({ id, payload } : { id: string; payload: any }) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", key);

  const requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: JSON.stringify(payload),
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/bawaslu_phwt/absensi/put/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const fetchDeleteAbsensiRecord = async (id : string) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions: RequestInit = {
    method: "DELETE",
    headers: myHeaders,
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/bawaslu_phwt/absensi/delete/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}